import { Button } from 'react-bootstrap';
import React from 'react';
import TableAction from '../../components/strategyProject/tabs/TabResults/TableAction/TableAction';
import style from '../../components/strategyProject/tabs/TabResults/TabResults.module.less';

export const status = {
  created: 'created',
  onApprove: 'onApprove',
  approved: 'approved',
  rejected: 'rejected',
};
export const status_ru = {
  created: 'Новый',
  onApprove: 'На согласовании',
  approved: 'Принят',
  rejected: 'Не согласован',
};
export const status_full = {
  isCreating: { key: 'isCreating', label: 'На заполнении', bg: 'primary' },
  created: { key: status.created, label: status_ru.created, bg: 'secondary' },
  onApprove: { key: status.onApprove, label: status_ru.onApprove, bg: 'warning' },
  approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
  rejected: { key: status.rejected, label: status_ru.rejected, bg: 'danger' },
  // inProgress: { key: status.inProgress, label: status_ru.inProgress, bg: 'secondary' },
  // returned: { key: status.returned, label: status_ru.returned, bg: 'secondary' },
  // approved: { key: status.approved, label: status_ru.approved, bg: 'success' },
  // declined: { key: status.declined, label: status_ru.declined, bg: 'danger' },
  // onProjOffice: { key: status.onProjOffice, label: status_ru.onProjOffice, bg: 'warning' },
};

const incomeTypes = [
  'х/д',
  'Гранты',
  'Инновационная продукция',
];
const incomeTypesWithNck = [
  'х/д',
  'Гранты',
  'Конкурсные проекты за счет средств Минобрнауки РФ и других ведомств',
  'Инновационная продукция',
];

export const incomeTypesWithNckObject = incomeTypesWithNck.map((val, index) => ({ id: index, incomeTitle: val }));

export const inComeTypesObject = incomeTypes.map((val, index) => ({ id: index, incomeTitle: val }));
